"use strict";
exports.__esModule = true;
var logger_1 = require("@gaming/logger");
var ConsoleLogger = (function () {
    function ConsoleLogger() {
    }
    ConsoleLogger.prototype.log = function (tag, level, message) {
        switch (level) {
            case logger_1.LogLevel.Debug:
                console.debug(tag + ": " + message);
                break;
            case logger_1.LogLevel.Warn:
                console.warn(tag + ": " + message);
                break;
            case logger_1.LogLevel.Error:
                console.error(tag + ": " + message);
                break;
            case logger_1.LogLevel.Info:
            default:
                console.log(tag + ": " + message);
                break;
        }
    };
    return ConsoleLogger;
}());
exports.console_assert = function (condition, message) {
    console.assert(condition, message);
};
var impl;
var LogProvider = (function () {
    function LogProvider(tag, callerImpl) {
        this.tag = "GTL[" + tag + "]";
        if (callerImpl) {
            impl = callerImpl;
        }
        else if (!impl) {
            impl = new ConsoleLogger();
        }
    }
    LogProvider.prototype.logInternal = function (level, message) {
        impl.log(this.tag, level, message);
    };
    LogProvider.prototype.debug = function (message) {
        this.logInternal(logger_1.LogLevel.Debug, message);
    };
    LogProvider.prototype.warn = function (message) {
        this.logInternal(logger_1.LogLevel.Warn, message);
    };
    LogProvider.prototype.error = function (message) {
        this.logInternal(logger_1.LogLevel.Error, message);
    };
    LogProvider.prototype.info = function (message) {
        this.logInternal(logger_1.LogLevel.Info, message);
    };
    return LogProvider;
}());
exports.LogProvider = LogProvider;
//# sourceMappingURL=Logging.js.map